export default "__VITE_ASSET__BAqDoWmy__"